var MessagesHelpers = /** @class */ (function () {
    /**
     * Class constructor
     * @returns {void}
     */
    function MessagesHelpers() {
    }
    /**
     * Class initializer
     * * @param {any} intl Intl provider
     * */
    MessagesHelpers.prototype.Initialize = function (intl) {
        this.Intl = intl;
    };
    /**
     * Get translation messagge
     * @param {string} id Id of the translation message to get
     */
    MessagesHelpers.prototype.GetMessage = function (id) {
        return this.Intl.formatMessage({
            id: id
        });
    };
    return MessagesHelpers;
}());
var Messages = new MessagesHelpers();
export default Messages;
//# sourceMappingURL=Messages.js.map